import * as React from 'react'
import { Link } from 'react-router-dom'

import * as styles from './menuItem.module.css'

interface IProps {
  to: string
  children: React.ReactNode
}

const MenuItem: React.SFC<IProps> = ({ to, children }) => {
  return (
    <li className={styles.root}>
      <Link to={to} className={styles.link}>
        {children}
      </Link>
    </li>
  )
}

export default MenuItem
